import Conditional from 'decorators/conditional';
import Mobile from '@sp/ui/pages/FlexPage/index.mobile';
import Desktop from './index.desktop';

export default Conditional({
  desktop: Desktop,
  mobile: Mobile,
  default: Mobile,
});
